<template>
  <v-toolbar
      id="header-toolbar"
      flat
      dark>
    <v-toolbar-title v-if="mobile">
      <a href="/">
        <img src="../assets/img-logo-landing-sm.svg" alt="Everybike logo"/>
      </a>
    </v-toolbar-title>
    <v-toolbar-title v-else>
      <a href="/">
        <img src="../assets/img-logo-landing.svg" alt="Everybike logo"/>
      </a>
    </v-toolbar-title>
  </v-toolbar>
</template>
<script>
export default {
  methods: {
    mobile() {
      return this.$vuetify.breakpoint.sm
    }
  }
}
</script>
<style lang="scss">

#header-toolbar {
  margin-left: auto;
  margin-right: auto;
  color: white;
  background-color: rgba(255, 255, 255, 0.3);
  max-height: 65px;
  margin-bottom: -65px;
  .v-toolbar__content {
    max-width: 1280px;
    margin-left: 102px;
    @media screen and (max-width: 960px) {
      margin-left: 26px;
    }
  }

}
</style>